import React, { Component } from "react";
import { Icon, Dropdown } from "semantic-ui-react";
import "./index.css";

class CaseActionsDropdown extends Component {
  constructor(props) {
    super(props);
    this.post = this.props.post;
  }

  render() {
    return (
      <div className="case-dropdown">
        <Dropdown
          trigger={<Icon name="ellipsis horizontal" size="large" color="grey" className="-ellipsis-nav" />}
          options={this.props.options}
          pointing="top right"
          icon={null}
        />
      </div>
    );
  }
}

export default CaseActionsDropdown;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/CaseActionsDropdown/index.js